module.exports = __webpack_public_path__ + "static/media/solo_hymen0.8ce39055.svg";